module.exports = __webpack_public_path__ + "img/6.737c1544.svg";